"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileList = void 0;
var react_1 = __importStar(require("react"));
var react_device_detect_1 = require("react-device-detect");
var filesize_1 = __importDefault(require("filesize"));
var classnames_1 = __importDefault(require("classnames"));
require("./FileList.scss");
var FileList = /** @class */ (function (_super) {
    __extends(FileList, _super);
    function FileList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FileList.prototype.render = function () {
        var _this = this;
        var props = this.props;
        return (react_1.default.createElement("div", { className: "file-list" },
            react_1.default.createElement("div", { className: "file-list-items-container" }, props.files.map(function (f, i, arr) {
                return (react_1.default.createElement("div", { key: f.filename, className: classnames_1.default('file-list-items', 'tooltip', { 'is-tooltip-bottom': (((i + 1) !== arr.length) || (arr.length === 1)) }, { 'is-tooltip-top': (((i + 1) === arr.length) && (arr.length !== 1)) }, { 'ie-specific': react_device_detect_1.isEdge || react_device_detect_1.isIE }), "data-tooltip": f.path ? f.path : f.filename },
                    react_1.default.createElement(FileListItem, { key: f.filename, file: f, onRemove: function () { return _this.props.onRemove(f); } })));
            }))));
    };
    return FileList;
}(react_1.Component));
exports.FileList = FileList;
var FileListItem = function (props) {
    var isDirectory = (props.file.type === 'inode/directory' || props.file.type === 'directory');
    var iconClassName = isDirectory ? 'fa-folder' : 'fa-file';
    return (react_1.default.createElement("div", { className: "file-list-item level is-mobile" },
        react_1.default.createElement("div", { className: "level-left" },
            react_1.default.createElement("div", { className: "level-item" },
                react_1.default.createElement("span", { className: "fileicon" },
                    react_1.default.createElement("i", { className: classnames_1.default('fas', iconClassName) })))),
        react_1.default.createElement("div", { className: "level-item filename-level-item" },
            "\u200E",
            props.file.filename),
        react_1.default.createElement("div", { className: "level-right" },
            !isDirectory &&
                react_1.default.createElement("div", { className: "level-item" },
                    react_1.default.createElement("span", { className: "is-size-7" }, filesize_1.default(props.file.size))),
            react_1.default.createElement("div", { className: "level-item" },
                react_1.default.createElement("a", { className: "remove-file has-text-light", onClick: props.onRemove },
                    react_1.default.createElement("i", { className: "fas fa-times" }))))));
};
